import {scaleLinear} from 'd3-scale';
import type {WeeklyDatum} from '../data';
import {fontFamily, theme} from '../theme';

const WIDTH = 1728;
const LEFT = 112;
const RIGHT = 34;

type TimelineProps = {
  rows: WeeklyDatum[];
  filteredCount: number;
  frame: number;
  dataProgress: number;
  domainStart: number;
  domainEnd: number;
  outroProgress: number;
};

export const Timeline = ({
  rows,
  filteredCount,
  frame,
  dataProgress,
  domainStart,
  domainEnd,
  outroProgress,
}: TimelineProps) => {
  const x = scaleLinear().domain([domainStart, domainEnd]).range([LEFT, WIDTH - RIGHT]);
  const cursorX = x(Math.min(dataProgress, rows.length - 1));
  const yearMarkers = rows
    .map((row, index) => ({year: row.startDate.slice(0, 4), index}))
    .filter((marker, index, all) => index === 0 || marker.year !== all[index - 1].year)
    .filter((marker) => marker.index >= domainStart && marker.index <= domainEnd);
  const tickStart = Math.ceil(domainStart / 4) * 4;
  const ticks = [];
  for (let index = tickStart; index <= domainEnd; index += 4) {
    ticks.push(index);
  }
  const pulse = 16 + 8 * Math.sin((frame / 60) * Math.PI * 2);

  return (
    <svg width={WIDTH} height={112} viewBox={`0 0 ${WIDTH} 112`}>
      <line x1={LEFT} x2={WIDTH - RIGHT} y1={60} y2={60} stroke={theme.line} strokeWidth={2} />
      {ticks.map((index) => (
        <line
          key={index}
          x1={x(index)}
          x2={x(index)}
          y1={54}
          y2={66}
          stroke={theme.muted}
          strokeOpacity={0.6}
        />
      ))}
      {yearMarkers.map((marker) => (
        <g key={marker.year}>
          <line x1={x(marker.index)} x2={x(marker.index)} y1={44} y2={70} stroke={theme.sessions} strokeOpacity={0.6} />
          <text
            x={x(marker.index)}
            y={31}
            fill={theme.muted}
            fontFamily={fontFamily}
            fontSize={18}
            textAnchor="middle"
          >
            {marker.year}
          </text>
        </g>
      ))}
      <circle cx={cursorX} cy={60} r={pulse} fill={theme.sessions} opacity={0.08} />
      <circle cx={cursorX} cy={60} r={11} fill={theme.sessions} opacity={0.22} />
      <circle cx={cursorX} cy={60} r={6} fill={theme.text} stroke={theme.sessions} strokeWidth={4} />
      <text
        x={WIDTH - RIGHT}
        y={103}
        fill={theme.muted}
        fontFamily={fontFamily}
        fontSize={16}
        textAnchor="end"
        letterSpacing={1}
      >
        {outroProgress > 0.5 ? `完整趋势 · ${rows.length} 周` : '最近 52 周'}
      </text>
      {filteredCount > 0 ? (
        <text
          x={LEFT}
          y={103}
          fill={theme.muted}
          fontFamily={fontFamily}
          fontSize={16}
          letterSpacing={1}
        >
          已过滤 {filteredCount} 周低频记录
        </text>
      ) : null}
    </svg>
  );
};
